import React from "react";
import Home from "../pages/Home";
import Features from "../pages/Features";
import About from "../pages/About";
import Footer from "../pages/Footer";
import Contact from "../pages/Contact";

const Container = () => {
  return (
    <>
      <div id="home">
        <Home />
      </div>
      <div id="features">
        <Features />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <div id="blog">
        <Footer />
      </div>
    </>
  );
};

export default Container;
